import axiosInstance from "@/api/axiosInstance";
import { ENDPOINTS } from "@/constants/api";
import { requestHandler } from "@/helpers/requestHandler";

/**
 * Interface for gear type data from the backend
 */
export interface GearType {
  id: number;
  name: string;
}

/**
 * Service for managing gear types
 */
export const GearTypeService = {
  /**
   * Get all gear types
   * @returns Array of gear types
   */
  async getAllGearTypes(): Promise<GearType[]> {
    return requestHandler<GearType[]>(async () => {
      const response = await axiosInstance.get(ENDPOINTS.GEAR.TYPES);
      return response.data || [];
    }, "GearTypeService -> getAllGearTypes");
  },

  /**
   * Get a gear type by ID
   * @param id - The ID of the gear type to retrieve
   * @returns The gear type or null if not found
   */
  async getGearTypeById(id: number): Promise<GearType | null> {
    return requestHandler<GearType | null>(async () => {
      const response = await axiosInstance.get(`${ENDPOINTS.GEAR.TYPES}/${id}`);
      return response.data || null;
    }, "GearTypeService -> getGearTypeById");
  },
};
